import { render, staticRenderFns } from "./tinymce.vue?vue&type=template&id=3bd8a734&scoped=true&lang=pug"
import script from "./tinymce.vue?vue&type=script&lang=js"
export * from "./tinymce.vue?vue&type=script&lang=js"
import style0 from "tinymce/skins/content/default/content.css?vue&type=style&index=0&id=3bd8a734&prod&rel=stylesheet&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8a734",
  null
  
)

export default component.exports